import React, { useContext } from "react";
import Progress from "antd/lib/progress";
import Popover from "antd/lib/popover";
import { intlContext } from "translations/context";
import { formatMoney } from "utils/formatters";

interface Props {
  investorCount: number;
  requiredBudgetInCt?: number;
  requiredMinBudgetInCt?: number;
  submittedAmountInCt: number;
  coFundingAmountInCt?: number;
  strokeColor?: string;
  style?: React.CSSProperties;
}

export default function ProgressBar({
  investorCount,
  requiredBudgetInCt,
  requiredMinBudgetInCt,
  submittedAmountInCt,
  coFundingAmountInCt,
  strokeColor,
  style
}: Props): JSX.Element {
  const { translate } = useContext(intlContext);
  if (requiredBudgetInCt == null || requiredBudgetInCt == null || submittedAmountInCt == null) return <React.Fragment />;

  const percent = ((submittedAmountInCt + (coFundingAmountInCt ?? 0)) * 100) / requiredBudgetInCt;
  const success = (submittedAmountInCt * 100) / requiredBudgetInCt;

  return (
    <div
      style={{
        width: "80%",
        marginBottom: 20,
        marginLeft: "auto",
        marginRight: "auto",
        ...style
      }}
    >
      {/* <Row style={{ paddingBottom: 4 }}>
        <Col span={12} style={{ textAlign: "left" }}>
          <span style={{ fontSize: "large" }}>
            <b>{percent.toFixed(0)}%</b>
          </span>&nbsp;
          <span>
            {translate("project_list_startpage_progress_bar_by")}&nbsp;
            {investorCount === 1
              ? `1 ${translate("project_list_startpage_progress_bar_investor")}`
              : `${investorCount} ${translate("project_list_startpage_progress_bar_investors")}`}
          </span>
        </Col>
        <Col span={12} style={{ textAlign: "right", color: "#a2a2a2" }}>
          {translate("project_list_startpage_progress_bar_requiredBudget")}: {formatMoney(requiredBudgetInCt)}
        </Col>
      </Row> */}
      <Popover
        content={
          <>
            {translate("project_list_startpage_progress_bar_requiredMinBudget")}: {formatMoney(requiredMinBudgetInCt, 0)}
          </>
        }
        placement="bottomLeft"
      >
        <Progress
          percent={percent}
          showInfo={false}
          success={{ percent: success, strokeColor: strokeColor ?? "rgb(24, 144, 255)" }}
          strokeColor={"rgb(144,201,72)"}
          strokeWidth={24}
          size="small"
        />
      </Popover>
      <div style={{ textAlign: "left", color: "#a2a2a2", paddingTop: 4, paddingLeft: 6 }}>
        <b>{formatMoney(submittedAmountInCt, 0)}</b>&nbsp;
        <span>
          {translate("project_list_startpage_progress_bar_by")}&nbsp;
          {investorCount === 1
            ? `1 ${translate("project_list_startpage_progress_bar_investor")}`
            : `${investorCount} ${translate("project_list_startpage_progress_bar_investors")}`}
        </span>
        {coFundingAmountInCt && coFundingAmountInCt !== 0 && (
          <>
            <br />
            <span>+ {formatMoney(coFundingAmountInCt, 0)} über Co-Funding</span>
            <p style={{ paddingTop: 3, fontSize: "1.1em" }}>
              =<b> {formatMoney(submittedAmountInCt + coFundingAmountInCt, 0)}</b> insgesamt
            </p>
          </>
        )}
      </div>
    </div>
  );
}
